const FinanceValidationMessages = {
  english: {
    custom: {
      financeTerm: {
        touchPointNumberInput: 'Please enter your desired contract term or select not sure.'
      },
      annualMileage: {
        touchPointNumberInput: 'Please enter your desired annual mileage or select not sure.'
      },
      depositMonths: {
        touchPointNumberInput: 'Please enter your desired deposit months or select not sure.'
      },
      monthlyBudget: {
        min_value: (_, values) => `Please enter your desired monthly budget, it must be £${values[0]} or more.`
      },
      depositAmount: {
        min_value: 'Please enter your desired deposit amount, it must be £1,000 or more.'
      }
    }
  }
};

export default FinanceValidationMessages;
